export default __webpack_public_path__ + "static/media/BeforePhoto5.2698d971.jpg";